import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AdminAuthContext = createContext({ admin: null, loading: true, refresh: () => {}, logout: async () => {} });

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try { const r = await api.get("/admin/me"); setAdmin(r.data); }
    catch { setAdmin(null); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => { try { await api.post("/admin/logout"); } catch {}; setAdmin(null); };
  return <AdminAuthContext.Provider value={{ admin, loading, refresh, logout }}>{children}</AdminAuthContext.Provider>;
};
export const useAdminAuth = () => useContext(AdminAuthContext);
